import api from '../api';

export default class RacasCoresService {
  constructor() {
    throw 'Não é possível instanciar RacasCoresService';
  }

  static async lista() {
    const endpoint = mergeEndpoint();
    return await api.get(endpoint);
  }
}

const mergeEndpoint = () => {
  return `racas-cores`;
};



// WEBPACK FOOTER //
// ./src/services/enums/racasCoresService.js